module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/404.aaf9d6b4.png";